import React from 'react';
import FormContainer from '../../../../Components/Form/FormContainer';
import InputField from '../../../../Components/Form/components/InputField';

const SerbiaAddressContainer: React.FC = () => {
	return (
		<FormContainer name={'address'}>
			<div className='row mb-3'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='street'
						label='component.serbiaAddressContainer.street'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='descriptiveNumber'
						label='component.serbiaAddressContainer.descriptiveNumber'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='guideNumber'
						label='component.serbiaAddressContainer.guideNumber'
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='city'
						label='component.serbiaAddressContainer.city'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='postCode'
						label='component.serbiaAddressContainer.postCode'
						isRequired
					/>
				</div>
			</div>
		</FormContainer>
	);
};

export default SerbiaAddressContainer;
